import { render, staticRenderFns } from "./parcelasRecebidas.vue?vue&type=template&id=57813842"
import script from "./parcelasRecebidas.vue?vue&type=script&lang=js"
export * from "./parcelasRecebidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports